import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import PageTransition from "./page-transition";
import Target from "./Cursor/target";
import "../styles/footer.scss";
import { EVENTS, getGlobals } from '../helpers/globals';

import ConnectFooter from "../svgs/connect-footer.svg";
import LogoSvg from '../svgs/logo.svg';

gsap.registerPlugin(ScrollTrigger);

const Footer: React.FC<any> = () => {
  const scroller = useRef(null);
  const footerRef = useRef(null);
  const momentumScrollContext = useRef(getGlobals('SMOOTH_SCROLL_CONTEXT'));

  const handleScroll = (ev) => {
    // TODO:
  };

  const setUpScrollProxy = () => {
    scroller.current = document.querySelector(`#hp-momentum-scroll`);
    ScrollTrigger.scrollerProxy(scroller.current, {
      scrollTop (value) {
        if (arguments.length) {
          if (momentumScrollContext.current) {
            momentumScrollContext.current.scrollTop = value;
          }
        }
        return momentumScrollContext.current?.scrollTop;
      }
    });
    if (momentumScrollContext.current) {
      momentumScrollContext.current?.addListener(ScrollTrigger.update);
    }
    ScrollTrigger.defaults({ scroller: scroller.current });
    initScrollAnims();
  }

  const initScrollAnims = () => {
    gsap.to('.hp-footer-bg', {
      height: '100%',
      background: '#0700FF',
      color: 'white',
      duration: 1,
      scrollTrigger: {
        trigger: '#hp-footer',
        toggleActions: "play none none none",
      }
    });
    gsap.to('.hp-footer-content', {
      color: 'white',
      duration: 1,
      scrollTrigger: {
        trigger: '#hp-footer',
        toggleActions: "play none none none",
      }
    });
  };


  useEffect(() => {
    window.addEventListener(EVENTS.onSmoothScrollInit, () => {
      momentumScrollContext.current = getGlobals('SMOOTH_SCROLL_CONTEXT');
      if (typeof momentumScrollContext.current.addListener === 'function') {
        momentumScrollContext.current.addListener(handleScroll);
      }
      setUpScrollProxy();
    });

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener(EVENTS.onSmoothScrollInit, () => {});
      }
    }
  }, []);

  const openMailTo = () => {
    window.location.href = "mailto:tkhariprasath@gmail.com"
  }

  return (
    <footer id="hp-footer" ref={footerRef}>
      <div className="hp-footer-bg" />
      <div className="hp-footer-content">
        <div className="hp-footer-top-content">
          <div className="hp-footer-left">
            <div className="hp-footer-connect">
              <ConnectFooter />
            </div>
            <Target className="emailme" onClick={openMailTo}>Or email me at<br />tkhariprasath@gmail.com</Target>
          </div>
          <div className="hp-footer-center">
            <div className="hp-title">Navigate</div>
            <ul>
              <li><Target><PageTransition to="/works">Works</PageTransition></Target></li>
              <li><Target><PageTransition to="/about">About me</PageTransition></Target></li>
              <li><Target><PageTransition to="/resume">Resume</PageTransition></Target></li>
            </ul>
          </div>
          <div className="hp-footer-right">
            <div className="hp-title">Let's be friends</div>
            <ul>
              <li><Target>Linkedin</Target></li>
              <li><Target>Instagram</Target></li>
              <li><Target>Twitter</Target></li>
              <li><Target>Behance</Target></li>
              <li><Target>Facebook</Target></li>
            </ul>
          </div>
        </div>
        <div className="hp-footer-bottom-content">
          <div className="hp-footer-logo">
            <LogoSvg />
          </div>
          <p>©️ 2020 With ❤️ from India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
